import Qs from 'qs'
import { Message, Loading } from 'element-ui';
import router from '@/routes.js'
import Vue from 'vue';
// 配置API接口地址
var root = process.env.API_URL
// 引用axios
var axios = require('axios')

/** 全局加载loading ==========================================开始 */
let loading        //定义loading变量

function startLoading() {    //使用Element loading-start 方法
    loading = Loading.service({
        lock: true,
        text: '加载中……',
        background: 'rgba(0, 0, 0, 0.7)'
    })
}
function endLoading() {    //使用Element loading-close 方法
    loading.close()
}
//那么 showFullScreenLoading() tryHideFullScreenLoading() 要干的事儿就是将同一时刻的请求合并。
//声明一个变量 needLoadingRequestCount，每次调用showFullScreenLoading方法 needLoadingRequestCount + 1。
//调用tryHideFullScreenLoading()方法，needLoadingRequestCount - 1。needLoadingRequestCount为 0 时，结束 loading。
let needLoadingRequestCount = 0
export function showFullScreenLoading() {
    if (needLoadingRequestCount === 0) {
        startLoading()
    }
    needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
    if (needLoadingRequestCount <= 0) return
    needLoadingRequestCount--
    if (needLoadingRequestCount === 0) {
        endLoading()
    }
}

//http request 拦截器
axios.interceptors.request.use(
    config => {
        //showFullScreenLoading()
        return config;
    },
    error => {
        return Promise.reject(err);
    }
);
 
//http response 拦截器
axios.interceptors.response.use(
    response => {
        // //当返回信息为未登录或者登录失效的时候重定向为登录页面
        // if(response.data.code == 'W_100004' || response.data.message == '用户未登录或登录超时，请登录！'){
        //     router.push({
        //         path:"/",
        //         querry:{redirect:router.currentRoute.fullPath}//从哪个页面跳转
        //     })
        // }
        //tryHideFullScreenLoading()
        return response;
    },
    error => {
        return Promise.reject(error)
    }
)
 
/** 全局加载loading ==========================================结束 */


// 自定义判断元素类型JS
function toType (obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}
// 参数过滤函数
function filterNull (o) {
  for (var key in o) {
    if (o[key] == null) {
      delete o[key]
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim()
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key])
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key])
    }
  }
  return o
}

/*
 接口处理函数
 这个函数每个项目都是不一样的，我现在调整的是适用于
 https://cnodejs.org/api/v1 的接口，如果是其他接口
 需要根据接口的参数进行调整。参考说明文档地址：
 https://cnodejs.org/topic/5378720ed6e2d16149fa16bd
 主要是，不同的接口的成功标识和失败提示是不一致的。
 另外，不同的项目的处理方法也是不一致的，这里出错就是简单的alert
*/
function apiFormAxios (method, url, params, success, failure) {
  if (params) {
    params = filterNull(params)
  }
  axios({
    //headers: {'Content-Type': 'multipart/form-data'},
     headers: { 'Content-Type': 'application/x-www-form-urlencode' },
    method: method,
    url: url,
    data: (method === 'POST' || method === 'PUT') ? params : null,
    params: (method === 'GET' || method === 'DELETE') ? params : null,
    baseURL: root,
    withCredentials: true
  }).then(function (res) {
    if (res.data.status === 600) {
        top.location.href = process.env.EXIT_URL
    } else {
      if (success) {
        success(res.data)
      }
    }
  }).catch(function (err) {
    let res = err.response
    if (err) {
      window.alert('api error, HTTP CODE: ' + res)
    }
  })
}

function apiAxios (method, url, header, params, success, failure) {
  var uuid = Vue.prototype.$util.UUID();    //加上随机数防止ie浏览器缓存
  if (params) {
    params = filterNull(params);
    params.t=uuid
  } else {
    params={t:uuid};
  }
  axios({
    method: method,
    url: url,
    headers: header,
    data: (method === 'POST' || method === 'PUT') ? Qs.stringify(params, { indices: false }) : null,
    params: (method === 'GET' || method === 'DELETE') ? params : null,
    baseURL: root,
    withCredentials: true
  }).then(function (res) {
    if(res.data == null){
        window.alert('网络访问出现异常');
        return; 
    }
    if (res.data.code === '600') {
        let curPath = router.currentRoute.path;
        if(curPath.startsWith('/mobile')){
            router.push({ path: '/mobileLogin'});
        } else {
            top.location.href = process.env.EXIT_URL
        }
    } else {
        if (success) {
            success(res.data)
        }
    }
  }).catch(function (err) {
    let res = err.response
    if (err) {
      window.alert('网络访问出现异常,请检测网络！');
      console.info(err);
    }
  })
}

function apiAxios1 (method, url, header, params, success) {
  const root1 = process.env.API_URL2
 // var uuid = Vue.prototype.$util.UUID();    //加上随机数防止ie浏览器缓存
  // if (params) {
  //   params = filterNull(params);
  //   params.t=uuid
  // } else {
  //   params={t:uuid};
  // }

  axios({
    method: method,
    url: url,
    headers: header,
    data: (method === 'POST' || method === 'PUT') ?params : null,
    params: params,
    baseURL: root,
    withCredentials: true
  }).then(function (res) {
    if(res.data == null){
        window.alert('网络访问出现异常');
        return; 
    }
    if (res.data.code === '600') {
        let curPath = router.currentRoute.path;
        if(curPath.startsWith('/mobile')){
            router.push({ path: '/mobileLogin'});
        } else {
            top.location.href = process.env.EXIT_URL
        }
    } else {
        if (success) {
            success(res.data)
        }
    }
  }).catch(function (err) {
    let res = err.response
    if (err) {
      window.alert('网络访问出现异常,请检测网络！');
      console.info(err);
    }
  })
}

function apiAxios2 (method, url, header, params, success) {
 // var uuid = Vue.prototype.$util.UUID();    //加上随机数防止ie浏览器缓存
  // if (params) {
  //   params = filterNull(params);
  //   params.t=uuid
  // } else {
  //   params={t:uuid};
  // }

  axios({
    method: method,
    url: url,
    headers: header,
    data: (method === 'POST' || method === 'PUT') ?params : null,
    params: params,
    baseURL: root,
    withCredentials: true
  }).then(function (res) {
    if(res.data == null){
        window.alert('网络访问出现异常');
        return; 
    }
    if (res.data.code === '600') {
        let curPath = router.currentRoute.path;
        if(curPath.startsWith('/mobile')){
            router.push({ path: '/mobileLogin'});
        } else {
            top.location.href = process.env.EXIT_URL
        }
    } else {
        if (success) {
            success(res.data)
        }
    }
  }).catch(function (err) {
    let res = err.response
    if (err) {
      window.alert('网络访问出现异常,请检测网络！');
      console.info(err);
    }
  })
}


// 返回在vue模板中的调用接口
export default {
  getaddHeader: function (url, header, params, success, failure) {
    return apiAxios1('GET', url, header, params, success, failure)
  },
  get: function (url, params, success, failure) {
    return apiAxios('GET', url, null, params, success, failure)
  },
  post: function (url, params, success, failure) {
    return apiAxios('POST', url, null, params, success, failure)
  },
  postHeader: function (url, header, params, success, failure) {
    return apiAxios1('POST', url, header, params, success, failure)
  },
  postHeader1: function (url, header, params, success, failure) {
    return apiAxios2('POST', url, header, params, success, failure)
  },
  postBody: function(url, header, params, success, failure){
    return apiAxios(
      'POST', 
      url, 
      header, 
      params, 
      success, 
      failure
    )
  },
  put: function (url, params, success, failure) {
    return apiAxios('PUT', url, null, params, success, failure)
  },
  delete: function (url, params, success, failure) {
    return apiAxios('DELETE', url, null, params, success, failure)
  },
  formpost: function (url, params, success, failure) {
    return apiFormAxios('POST', url, params, success, failure)
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js